import {
  Breadcrumb,
  Button,
  PageHeader,
  Table,
  message,
  Tag,
  Modal,
} from "antd";

import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import { useReactToPrint } from "react-to-print";
import Page from "_components/Page";
import { extraService, stockReceiptService, taxTypeService } from "_services";
import Search from "./Search";
import ExportExcel from "_helpers/ExportExcel";
import "../style.css";
import { CurrencyFormatter } from "_helpers/formatters";

const TiepList = ({ match }) => {
  const { path } = match;
  const [loading, setLoading] = useState(false);
  const [loadingBarcode, setLoadingBarcode] = useState(false);
  const [loadingExcel, setLoadingExcel] = useState(false);
  const [loadingPdf, setLoadingPdf] = useState(false);
  const [items, setItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(25);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchParams, setSearchParams] = useState("?orderStage=ALL");
  const [barcodeContent, setBarcodeContent] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [taxTypes, setTaxtypes] = useState([]);
  const componentRef = useRef();

  useEffect(() => {
    getTaxTypes();
    getPurchaseOrders(pageNumber, pageSize);
  }, []);

  const getTaxTypes = () => {
    taxTypeService
      .getAll()
      .then((data) => setTaxtypes(data.content))
      .catch((error) => message.error(error));
  };

  const getPurchaseOrders = (pageNumber, pageSize) => {
    let paginationParams = searchParams.indexOf("?") === -1 ? "?" : "&";
    paginationParams += `pageNumber=${pageNumber}&pageSize=${pageSize}`;

    setLoading(true);
    stockReceiptService
      .search(`${searchParams}${paginationParams}`)
      .then((data) => {
        setItems(data.content);
        setLoading(false);
        setTotalRecords(data.pagination.totalRecords);
        setPageNumber(pageNumber);
      })
      .catch((error) => {
        //this.setState({ loading: false, error });
        setLoading(false);
      });
  };

  const handleSearchResults = (results, totalRecords, searchParams) => {
    setItems(results);
    setTotalRecords(totalRecords);
    setSearchParams(searchParams);
    setPageNumber(1);
    setLoading(false);
  };

  const handlePaginateChange = (pageNumber, pageSize) => {
    getPurchaseOrders(pageNumber, pageSize);
  };

  const handleDelete = (id) => {
    stockReceiptService
      .delete(id)
      .then((x) => {
        message.success("Successfully deleted!");
        getPurchaseOrders(pageNumber, pageSize);
      })
      .catch((error) => {
        message.error(`${error}`);
      });
  };

  const handlePrintPdf = (stockPreReceipt) => {
    setSelectedItem(stockPreReceipt);
    setLoadingPdf(true);
    stockReceiptService.printPdf(stockPreReceipt.id).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `Stock-in-${stockPreReceipt.preReceiptNumber}.pdf`
      );
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      setLoadingPdf(false);
    });
  };

  const handlePrintBarcode = (stockPreReceipt) => {
    setSelectedItem(stockPreReceipt);
    setLoadingBarcode(true);
    /* purchaseOrderService
      .printBarcode(stockPreReceipt.id)
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `Barcodes_${stockPreReceipt.preReceiptNumber}.pdf`
        );
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        setLoadingBarcode(false);
      })
      .catch(() => {
        setLoadingBarcode(false);
      }); */
    extraService
      .getBarcode()
      .then((respose) => {
        setBarcodeContent(respose.content);
        setIsModalVisible(true);
        setLoadingBarcode(false);
      })
      .catch(() => {
        setLoadingBarcode(false);
      });
  };

  const handleExportExcel = () => {
    setLoadingExcel(true);
    stockReceiptService
      .exportExcel(searchParams)
      .then((response) => {
        const url = window.webkitURL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `Stock-Receipt_${moment(new Date()).format("YYYY-MM-DD")}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        setLoadingExcel(false);
      })
      .catch((error) => {
        setLoadingExcel(false);
        message.error(error);
      });
  };

  const handleOk = useReactToPrint({
    content: () => componentRef.current,
  });

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const getActionButtons = () => {
    let buttons = [];
    // buttons.push(
    //   <Button
    //     key="excel"
    //     icon={<FileExcelOutlined />}
    //     onClick={handleExportExcel}
    //     loading={loadingExcel}
    //   >
    //     Download Excel
    //   </Button>
    // );

    buttons.push(
      <Link to={`${path}/add`} key="btn-upload-asycuda">
        <Button>Add</Button>
      </Link>
    );

    buttons.push(
      <Link to={`${path}/upload-asycuda`} key="btn-upload-asycuda">
        <Button>AsyCuda Upload</Button>
      </Link>
    );

    return buttons;
  };

  const getColumns = () => [
    {
      title: "Customs Ref.Number",
      key: "customRefNumber",
      width: "5%",
      dataIndex: "customRefNumber",
      render: (text, record) => (
        <Link to={`/stock-receipts/${record.id}/summary`}>{text}</Link>
      ),
    },
    {
      title: "GRN Number",
      dataIndex: "receiptNumber",
      width: "5%",
      key: "receiptNumber",
    },
    {
      title: "Receipt Type",
      key: "receiptType",
      width: "10%",
      dataIndex: "receiptType",
      render: (text, record) => (text == "LOCAL" ? "INDIRECT" : "DIRECT"),
    },
    {
      title: "Receipt Date",
      dataIndex: "receivedDate",
      width: "8%",
      key: "receivedDate",
      render: (text, record) => moment(text).format("YYYY-MM-DD"),
    },
    {
      title: "VAT",
      dataIndex: "totalVatAmount",
      align: "right",
      key: "totalVatAmount",
      render: (text, record) => CurrencyFormatter(text ?? 0),
    },
    {
      title: "Gurantee",
      dataIndex: "totalLiabilityAmount",
      align: "right",
      key: "totalLiabilityAmount",
      render: (text, record) => <b>{CurrencyFormatter(text ?? 0)}</b>,
    },

    ...(taxTypes ?? []).map((item) => ({
      title: `${item.name}`,
      dataIndex: ["stockReceiptTaxViews"],
      align: "right",
      key: `${item.code}`,
      render: (text, record) => {
        const taxEntry = record.stockReceiptTaxViews?.find(
          (tax) => tax.code === item.code
        );
        return <b>{CurrencyFormatter(taxEntry?.totalTaxAmount ?? 0)}</b>;
      },
    })),
    /* {
      title: "Received Person",
      dataIndex: "receivingPerson",
      align: "center",
      key: "receivingPerson",
    }, */
    {
      title: "Status",
      dataIndex: "orderStage",
      key: "orderStage",
      width: "5%",
      render: (orderStatus) => {
        let color = "";
        if (orderStatus === "COMPLETE") {
          color = "#87d068";
        }
        if (orderStatus === "OPEN") {
          color = "#2db7f5";
        }
        if (orderStatus === "IN_PROGRESS") {
          color = "#108ee9";
        }
        return <Tag color={color}>{orderStatus}</Tag>;
      },
    },
    // {
    //   title: "Action",
    //   key: "action",
    //   render: (text, record) => {
    //     return (
    //       <span>
    //         {record.orderStage === "OPEN" && (
    //           <Popconfirm
    //             title="Are you sure to delete this item?"
    //             onConfirm={() => handleDelete(record.id)}
    //           >
    //             <CloseOutlined />
    //           </Popconfirm>
    //         )}
    //         {record.orderStage === "OPEN" && (
    //           <Button
    //             icon={<EditOutlined />}
    //             title="Edit"
    //             type="link"
    //             style={{ marginRight: 10 }}
    //             href={`/material-requests/${record.id}/edit`}
    //           ></Button>
    //         )}
    //         <Button
    //           icon={<FilePdfOutlined />}
    //           title="Print PDF"
    //           type="link"
    //           style={{ marginRight: 10 }}
    //           loading={loadingPdf && selectedItem.id === record.id}
    //           onClick={() => handlePrintPdf(record)}
    //         ></Button>
    //         {/* <Button
    //           icon={<BarcodeOutlined />}
    //           title="Print Barcodes"
    //           type="link"
    //           style={{ marginRight: 10 }}
    //           loading={loadingBarcode && selectedItem.id === record.id}
    //           onClick={() => handlePrintBarcode(record)}
    //         ></Button> */}
    //       </span>
    //     );
    //   },
    // },
  ];

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/stock-receipts">Search Imports</Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={getActionButtons()}
      >
        <Page inner>
          <Search
            showSearchLoading={setLoading}
            onSearchResults={handleSearchResults}
          />
          <Table
            bordered
            loading={loading}
            rowKey="id"
            size="small"
            scroll={{ x: 1800 }}
            columns={getColumns()}
            dataSource={items}
            pagination={{
              current: pageNumber,
              pageSize: pageSize,
              total: totalRecords,
              showTotal: (total) => `Total ${total} items`,
              showSizeChanger: false,
              onChange: handlePaginateChange,
            }}
          />
          <Modal
            title="Print Barcode"
            visible={isModalVisible}
            onOk={handleOk}
            onCancel={handleCancel}
            okText="Print"
          >
            <div ref={componentRef}>
              <img src={barcodeContent} />
            </div>
          </Modal>
        </Page>
      </PageHeader>
    </div>
  );
};

export default TiepList;
